var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCross1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1884_5828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99428 14.657C11.6737 14.657 14.6565 11.6742 14.6565 7.99477C14.6565 4.31531 11.6737 1.33252 7.99428 1.33252C4.31482 1.33252 1.33203 4.31531 1.33203 7.99477C1.33203 11.6742 4.31482 14.657 7.99428 14.657Z",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99344 5.99609L5.99609 9.99344",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 5.99609L9.99344 9.99344",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1884_5828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCross1);
export default __webpack_public_path__ + "static/media/circle_cross1.3a564adaea67a8b46a006b2d52365ac1.svg";
export { ForwardRef as ReactComponent };